import Vue from "vue";
import Vuex from "vuex";
import customer from './modules/customer'
import authentication from './modules/authentication'
import storeManager from './modules/storeManager'
import tracking from './modules/tracking'
import bigPackage from './modules/bigPackage'
import bigPackageVN from './modules/bigPackageVN'
import configuration from './modules/configuration'
import staff from './modules/staff'
import payOrder from './modules/payOrder'
import paymentHistory from './modules/paymentHistory'
import rechargeHistory from './modules/rechargeHistory'
import report from './modules/report'
import commons from './modules/commons'
import order from './modules/order'
import product from './modules/product'
import bill from './modules/bill'
import dashboard from './modules/dashboard'
import storage from './modules/storage'
import productType from './modules/productType'
import feeWeight from './modules/feeWeight'
import feeWeightEcom from './modules/feeWeightEcom'
import feeVolume from './modules/feeVolume'
import costWeight from './modules/costWeight'
import orderProduct from './modules/orderProduct'
import billProduct from './modules/billProduct'
import quote from './modules/quote'
import quote_packages from "./modules/quote_packages";
import auditLog from './modules/auditLog'
import customerDebt from './modules/customerDebt'
import exportRequest from './modules/exportRequest'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    customer,
    authentication,
    tracking,
    storeManager,
    bigPackage,
    bigPackageVN,
    feeWeight,
    feeWeightEcom,
    feeVolume,
    costWeight,
    configuration,
    staff,
    payOrder,
    paymentHistory,
    report,
    rechargeHistory,
    commons,
    product,
    order,
    bill,
    dashboard,
    storage,
    productType,
    orderProduct,
    quote,
    billProduct,
    quote_packages,
    auditLog,
    customerDebt,
    exportRequest
  },
  state: {},
  mutations: {},
  actions: {},
  strict: false,
  plugins: [createPersistedState({paths:['authentication', 'commons', 'roles'], storage: window.localStorage})]
});
